export default "__VITE_ASSET__BJr7o4X9__"